<template>
  <div class="investigacion">
    <v-container fluid style="position:relative" v-if="data !== null">
      <v-row justify="center" style=" position:relative" no-gutters>
        <v-col cols="12" md="7" lg="7" xl="6" class="content-wrapper">
          <v-img
            class="image__investigacion"
            v-if="images.length > 0"
            width="100%"
            height="350px"
            :src="images[0]"
          >
            <h4 class="image-inner-text">{{ this.data.title }}</h4>
          </v-img>
          <h5 class="notranslate">{{ $t("descripcion") }}</h5>
          <p class="body mt-3" v-html="data.description" />
          <h5 class="notranslate" v-if="data.mision">{{ $t("vision.title") }}</h5>
          <p class="body" v-html="data.mision" v-if="data.mision" />
          <h5 class="notranslate" v-if="data.vision">{{ $t("mision.title") }}</h5>
          <p class="body" v-html="data.vision" v-if="data.vision" />

          <div v-if="data.ca">
            <h5>Cuerpos Académicos</h5>
            <div class="px-3" v-for="ca in data.ca" :key="ca.name">
              <h6 class="grey-2" style="margin:40px 0;">{{ ca.name }}</h6>
              <div
                class="biografias "
                v-for="(integrante, index) in ca.integrantes"
                v-if="getWorker(integrante)"
                :key="integrante.name"
              >
                <WorkerCell
                  :workerDetails="showInfo"
                  :worker="getWorker(integrante)"
                  style="margin:20px 0 0 0; "
                />

                <v-expansion-panels style=" border-radius:0px" flat class="pt-0 ">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="grey-2">
                      Biografía
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p class="body-2 mt-3">{{ integrante.biografia }}</p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>

          <div v-if="data.ta">
            <h5>Técnicos Académicos</h5>
            <div
              class="biografias "
              v-if="getWorker({ id: integrante })"
              v-for="integrante in data.ta"
              :key="integrante"
            >
              <WorkerCell
                :workerDetails="showInfo"
                :worker="getWorker({ id: integrante })"
                style="margin:20px 0 0 0; "
              />
            </div>
          </div>

          <h5 v-if="data.publicaciones">Publicaciones</h5>
          <p class="body" v-if="data.publicaciones" v-html="data.publicaciones" />

          <h5 v-if="data.proyectos_vigentes">Proyectos vigentes</h5>
          <p class="body" v-if="data.proyectos_vigentes" v-html="data.proyectos_vigentes" />

          <h5 v-if="data.tesistas">Tesistas Activos</h5>
          <p class="body" v-if="data.tesistas" v-html="data.tesistas" />

          <h5 v-if="data.serv_y_lab">Servicios y Laboratorios</h5>
          <div class="px-3" v-if="data.serv_y_lab">
            <h6 class="grey-2" v-if="data.serv_y_lab.laboratorios">Laboratorios</h6>
            <p
              class="body"
              v-if="data.serv_y_lab.laboratorios"
              v-html="data.serv_y_lab.laboratorios"
            />
            <h6 class="grey-2" style="margin: 0 20px" v-if="data.serv_y_lab.servicios">
              Servicios
            </h6>
            <p class="body" v-if="data.serv_y_lab.servicios" v-html="data.serv_y_lab.servicios" />
          </div>

          <h5 v-if="data.estudiantes">Dirección de estudiantes</h5>
          <p class="body" v-if="data.estudiantes" v-html="data.estudiantes" />
        </v-col>

        <v-col cols="2" style="max-width:300px; width: 300px !important; position:relative">
          <div v-if="!isTablet" class="aside notranslate">
            <div class="wrapper-shit">
              <h6>{{ $t("investigacion.title") }}</h6>
              <div class="options  ">
                <router-link
                  :to="{ path: '/investigacion/Acuacultura' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.acuacultura") }}
                </router-link>
                <router-link
                  :to="{ path: '/investigacion/ecologia-marina-integrativa' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.ecologia") }}
                </router-link>
                <router-link
                  :to="{ path: '/investigacion/biogeoquimica-marina-y-cambio-global' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.biogeoquimica") }}
                </router-link>
                <router-link
                  :to="{ path: '/investigacion/ciencias-ambientales-y-del-agua' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.ciencias") }}
                </router-link>
                <router-link
                  :to="{ path: '/investigacion/oceanografia-fisica' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.oceanografia") }}
                </router-link>
                <!-- <router-link
                  :to="{ path: '/investigacion/laboratorio-de-paleoceanografia' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("investigacion.laboratorio") }}
                </router-link> -->
              </div>
              <h6 style="margin-top:95px">{{ $t("posgrados.title") }}</h6>

              <div class="options  ">
                <router-link
                  :to="{ path: '/posgrados/doctorado-en-medio-ambiente-y-desarrollo' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("posgrados.doctorado") }}
                </router-link>
                <router-link
                  :to="{ path: '/posgrados/oceanografia-costera' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("posgrados.oceanografia") }}
                </router-link>
                <router-link
                  :to="{ path: '/posgrados/gestion-ambiental' }"
                  class="links option-item"
                  style="width:300px"
                >
                  {{ $t("posgrados.gestion") }}
                </router-link>
              </div>
              <div class="calendar">
                <v-img :src="altLogo" width="180px" class="logo-uabc" />
                <h4 class="mt-10 notranslate">{{ $t("posgrados.calendario") }}</h4>
                <p class="links mt-1 mb-4 center-text">
                  {{ $t("calendar_msg") }}
                </p>
                <button class="notranslate read-more green-fill cta">
                  <a target="_blank" :href="calendarLink">{{ $t("posgrados.calendario") }}</a>
                </button>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <WorkerDetails :worker="selectedWorker" :open="workerDrawer" :close="closeDrawer" />
    </v-container>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "investigacion",
  //{v-container, v-row, v-col, v-img, v-expansion-panels, v-expansion-panel, v-expansion-panel-header, v-expansion-panel-content}
  components: {
    WorkerCell: () => import(/* webpackPrefetch: true */ "../components/Lists/WorkerCell.vue"),
    WorkerDetails: () => import(/* webpackPrefetch: true */ "../components/Form/workerDetails.vue")
  },
  data: () => ({
    isTablet: window.innerWidth < 960,
    data: null,
    publicPath: $(location).attr("origin") + "/archivos/investigacion/",
    images: [],
    selectedWorker: null,
    workerDrawer: false
  }),
  computed: {
    altLogo: () => require("../assets/logo_uabc_alt.png"),
    calendarLink: function() {
      return this.$info.about.information.calendarLink;
    },
    loadData() {
      this.images = [];
      this.data = this.$info.investigaciones.find(
        investigacion => investigacion.name === this.$route.params.especiality
      );
      if (!this.data) {
        this.$router.push({ name: "404" });
      } else {
        const loading = this.$loading();
        const { name } = this.data;
        $.getJSON($(location).attr("origin") + `/archivos/investigacion/${name}`, data => {
          if (data !== null)
            data.forEach((image, i) => {
              this.images.push(this.publicPath + `${name}/${image}`);
            });
          setTimeout(() => loading.close(), 300);
        });
      }
    }
  },
  methods: {
    showInfo(worker, state) {
      this.selectedWorker = worker;
      this.workerDrawer = state;
    },
    closeDrawer() {
      this.workerDrawer = false;
    },
    getWorker(worker) {
      const { id } = worker;
      return this.$info.about.personal.find(trabajador => trabajador.id === id);
    },
    onresize: function() {
      this.isTablet = window.innerWidth < 960;
    }
  },
  created: function() {
    this.loadData;
    window.addEventListener("resize", this.onresize);
  },
  destroyed: function() {
    window.removeEventListener("resize", this.onresize);
    this.$loading().close();
  },
  watch: {
    "$route.params.especiality": {
      handler: function(search) {
        this.loadData;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
h4 {
  text-align: left !important;
}
h5 {
  margin: 30px 0 15px 0;
}
h6 {
  border-left: $green solid 4px;
  padding-left: 5px;
  font-size: 20px;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 2vw !important;
  padding-right: 2vw !important;
  // px-10 d-flex flex-column
}
.biografias {
  padding-left: 1vw;
  padding-right: 1vw;
}
.read-more {
  width: 171px;
  height: 39px;
  * {
    color: white !important;
  }
}
.image-inner-text {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  padding-left: 10px;
  color: white;
}
.investigacion {
  display: flex;
  position: relative;
  padding-top: 100px;

  .image__investigacion {
    width: 623px;
    height: 245px;
    background-color: #c4c4c4;
    border-radius: 5px;
    align-self: center;
    margin: 50px auto;
  }
}
ul {
  padding-left: 35px;
}
.aside {
  // margin-top: 50px;
  position: -webkit-sticky;
  position: sticky;

  top: 50px; /* required */
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: left;
  width: 300px !important;
  .wrapper-shit {
    position: relative;
    margin-top: 60px;
  }
  // height: 100%;
  //background-color: red;
  .calendar {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 286px;
    height: 215px;
    background-color: #f4c268;
    border-radius: 10px;
    margin-top: 130px;
    .logo-uabc {
      position: absolute;
      top: -50px;
    }
  }
}
.options {
  display: flex;
  flex-direction: column;
  position: relative;
  .option-item {
    margin: 0 !important;
    padding-top: 18px;
  }
}
@media (max-width: 960px) {
  .investigacion {
    padding-top: 5px;
  }
  .biografias {
    padding-left: 0vw;
    padding-right: 0vw;
  }
}
</style>
<style lang="scss">
.investigacion {
  ul {
    padding-left: 35px !important;
  }
  .biografias {
    .v-expansion-panel {
      //border: none !important;
      border-color: rgba(0, 0, 0, 0.1);
    }
    .v-expansion-panel-header {
      height: 45px !important;
      display: flex;
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 17px;
      line-height: 25px;
      padding: 0 !important;
    }
    .v-expansion-panel-header__icon {
      //margin-left: 0;
    }
    .v-expansion-panel-content__wrap {
      padding-left: 0px !important;
    }
  }
}
@media (max-width: 960px) {
  .investigacion {
    ul {
      padding-left: 25px !important;
    }
    // .v-expansion-panel-header {
    //   margin: 0 auto;
    //   //border: none !important;
    //   max-width: 295px;
    // }
  }
}
</style>
